import { Container } from "react-bootstrap"
import PropertyCard from "./PropertyCard"

const Selling = ({ openingOffers, title }) => (

  <Container>
    <div className='title fz-34 mt-5 mb-4'>
      {title}
    </div>
    {
      openingOffers.map((offer =>
        (offer && <>
            <div className='show-lg mb-5'>
              <PropertyCard
                cardType='horizontal'
                {...offer}
              />
            </div>
            <div className='hide-lg'>
              <PropertyCard
                {...offer}
              />
            </div>
          </>
        )
      )
    )}
  </Container>

)

export default Selling
